/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : KDN V1.0
 * 설명 : 한전KDN 생성형 AI 기반 자료추출 SQL생성 및 이력관리 솔루션
 * 버전 : 1.0
 * 파일명 : submitPromoFilter.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정일 : 2025-09-16, 강동형 : 지역값 없을때 안불러오는 문제 수정
 * ================================================================ */
import { useDialogStore } from 'src/stores/DialogStore';
import { postPromoFilter } from 'src/api/Promo';
import { format } from 'date-fns';
import { usePromoDialogInterest } from 'src/stores/PromoStore';
import { postInterested } from 'src/api/Interested';
import { useStorageStore } from 'src/stores/StorageStore';
import { RegionsType } from 'src/types/SchoolType';

export const submitPromoFilter = async (pagination?: boolean) => {
  const {
    start_date,
    end_date,
    selected_Regions,
    edu_level,
    highschool_type,
    special_note,
    setOpen,
    setField,
    setResponse,
    page_Num,
    sort_by,
    sort_order,
    school_name
  } = useDialogStore.getState();
  const { getItem } = useStorageStore.getState(); // ← here
  const user = getItem?.("user");
  const user_area = (selected_Regions && Object.keys(selected_Regions).length > 0 ? selected_Regions : user?.data?.user_area) as RegionsType
  const format_start_date = start_date ? format(start_date, 'yyyy-MM-dd') : '';
  const format_end_date = end_date ? format(end_date, 'yyyy-MM-dd') : '';
  
  const regionEntries = Object.entries(user_area).map(([wide, cities]) => {
    const trimmedWide = wide.slice(0, 2);
    const filteredCities = cities.length === 1 && cities[0] === '전체' ? [] : cities;
    return [trimmedWide, filteredCities] as [string, string[]];
  });
  
  const response = await postPromoFilter({
    page: pagination ? page_Num : 1,
    start_date: format_start_date,
    end_date: format_end_date,
    loc: regionEntries,
    edu_level,
    highschool_type,
    special_note,
    sort_by: sort_by,
    sort_order: sort_order,
    school_name: school_name
  });
  const nextPage = pagination ? page_Num + 1 : 2;
  if (!response?.data) return
  if (pagination && page_Num !== 1) {
    // console.log('페이지네이션');
    setField('page_Num', nextPage);
    setResponse(response.data, nextPage);
    setField('total_rows',response.total_rows)
  } else {
    // console.log('셋필드');
    setField('page_Num', 2);
    setField('response_data', response.data);
    setField('total_rows',response.total_rows)
  }

  setOpen(false);
};

export const LoadPromoInterest = async(result_id:number, school_class:string, pagination?:boolean) =>{
  const {
    sort_by,
    page,
    sort_order,
    startCouncel,
    endCouncel,
    startBirth,
    endBirth,
    setField,
    gender,
    status,
    student_name,
    setResponse,
  } = usePromoDialogInterest.getState();
  
  const response = await postInterested({
    promotion_id:result_id,
    page: pagination ? page : 1,
    page_size:20,
    sort_by:sort_by,
    sort_order:sort_order,
    start_date: startCouncel,
    end_date: endCouncel,
    start_birthday: startBirth,
    end_birthday: endBirth,
    gender: gender,
    status: status,
    student_name: student_name,
    school_class:school_class
  })
  const nextPage = pagination ? page + 1 : 2;
  if (!response?.data) return
  if(pagination &&  page !== 1){
    setResponse(response.data, nextPage);
    setField('page',nextPage)
  }
  else{
    setField('response',response.data)
    setField('page',2)
  }
  setField('total_rows',response.total_rows)
  setField('isOpen',false)
}